
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/blog-posts/buzz-until-the-last-bell-how-curipod-sparks-curiosity-through-year-end-and-summer-learning",
      function () {
        return require("private-next-pages/c/blog-posts/buzz-until-the-last-bell-how-curipod-sparks-curiosity-through-year-end-and-summer-learning.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/blog-posts/buzz-until-the-last-bell-how-curipod-sparks-curiosity-through-year-end-and-summer-learning"])
      });
    }
  